export default __webpack_public_path__ + "static/media/savedIcon.77ead215.png";